export const containerSizes = [
  {
      "measurement": "4\"",
      "type": "Pot"
  },
  {
      "measurement": "5\"",
      "type": "Pot"
  },
  {
      "measurement": "6\"",
      "type": "Pot"
  },
  {
      "measurement": "8\"",
      "type": "Pot"
  },
  {
      "measurement": "10\"",
      "type": "Pot"
  },
  {
      "measurement": "12\"",
      "type": "Pot"
  },
  {
      "measurement": "14\"",
      "type": "Pot"
  },
  {
      "measurement": "18\"",
      "type": "Pot"
  },
  {
      "measurement": "20\"",
      "type": "Pot"
  },
  {
      "measurement": "21\"",
      "type": "Pot"
  },
  {
      "measurement": "24\"",
      "type": "Box"
  },
  {
      "measurement": "25\"",
      "type": "Box"
  },
  {
      "measurement": "30\"",
      "type": "Box"
  },
  {
      "measurement": "36\"",
      "type": "Box"
  },
  {
      "measurement": "40\"",
      "type": "Box"
  },
  {
      "measurement": "46\"",
      "type": "Box"
  },
  {
      "measurement": "50\"",
      "type": "Box"
  },
  {
      "measurement": "52\"",
      "type": "Box"
  },
  {
      "measurement": "60\"",
      "type": "Box"
  },
  {
      "measurement": "64\"",
      "type": "Box"
  },
  {
      "measurement": "72\"",
      "type": "Box"
  },
  {
      "measurement": "91\"",
      "type": "Box"
  },
  {
      "measurement": "102\"",
      "type": "Box"
  },
  {
      "measurement": "120\"",
      "type": "Box"
  },
  {
      "measurement": "140\"",
      "type": "Box"
  },
  {
      "measurement": "1G",
      "type": "Pot"
  },
  {
      "measurement": "2G",
      "type": "Pot"
  },
  {
      "measurement": "3G",
      "type": "Pot"
  },
  {
      "measurement": "5G",
      "type": "Pot"
  },
  {
      "measurement": "7G",
      "type": "Pot"
  },
  {
      "measurement": "10G",
      "type": "Pot"
  },
  {
      "measurement": "15G",
      "type": "Pot"
  },
  {
      "measurement": "20G",
      "type": "Pot"
  },
  {
      "measurement": "25G",
      "type": "Pot"
  },
  {
      "measurement": "30G",
      "type": "Pot"
  },
  {
      "measurement": "40G",
      "type": "Pot"
  },
  {
      "measurement": "50G",
      "type": "Pot"
  },
  {
      "measurement": "1c",
      "type": "Caliper"
  },
  {
      "measurement": "1.5c",
      "type": "Caliper"
  },
  {
      "measurement": "2c",
      "type": "Caliper"
  },
  {
      "measurement": "2.5c",
      "type": "Caliper"
  },
  {
      "measurement": "3c",
      "type": "Caliper"
  },
  {
      "measurement": "3.5c",
      "type": "Caliper"
  },
  {
      "measurement": "4c",
      "type": "Caliper"
  },
  {
      "measurement": "4.5c",
      "type": "Caliper"
  },
  {
      "measurement": "5c",
      "type": "Caliper"
  },
  {
      "measurement": "5.5c",
      "type": "Caliper"
  },
  {
      "measurement": "6c",
      "type": "Caliper"
  },
  {
      "measurement": "6.5c",
      "type": "Caliper"
  },
  {
      "measurement": "7c",
      "type": "Caliper"
  },
  {
      "measurement": "7.5c",
      "type": "Caliper"
  },
  {
      "measurement": "8c",
      "type": "Caliper"
  },
  {
      "measurement": "8.5c",
      "type": "Caliper"
  },
  {
      "measurement": "9c",
      "type": "Caliper"
  },
  {
      "measurement": "9.5c",
      "type": "Caliper"
  },
  {
      "measurement": "10c",
      "type": "Caliper"
  },
  {
      "measurement": "38p",
      "type": "Plug"
  },
  {
      "measurement": "50p",
      "type": "Plug"
  },
  {
      "measurement": "72p",
      "type": "Plug"
  },
  {
      "measurement": "98p",
      "type": "Plug"
  },
  {
      "measurement": "128p",
      "type": "Plug"
  },
  {
      "measurement": "144p",
      "type": "Plug"
  },
  {
      "measurement": "200p",
      "type": "Plug"
  },
  {
      "measurement": "288p",
      "type": "Plug"
  }
];